import { render, staticRenderFns } from "./person-roster.vue?vue&type=template&id=e4dcda74&scoped=true"
import script from "./person-roster.vue?vue&type=script&lang=ts"
export * from "./person-roster.vue?vue&type=script&lang=ts"
import style0 from "./person-roster.vue?vue&type=style&index=0&id=e4dcda74&prod&lang=less&scoped=true"
import style1 from "./person-roster.vue?vue&type=style&index=1&id=e4dcda74&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4dcda74",
  null
  
)

export default component.exports